export default {
  strict: true,
  namespaced: true,
  state: {
    show: false,
    loading: false,
    airline: {
      name: '',
      code: ''
    },
    flightNumber: '',
    departure: {
      airportCode: '',
      airportName: '',
      time: ''
    },
    arrival: {
      airportCode: '',
      airportName: '',
      time: ''
    },
    status: '',
    type: ''
  },
  mutations: {
    show (state) {
      state.show = true
      state.loading = true
    },
    hide (state) {
      state.show = false
      state.loading = false
      state.airline = {
        name: '',
        code: ''
      }
      state.flightNumber = ''
      state.departure = {
        airportCode: '',
        airportName: '',
        time: ''
      }
      state.arrival = {
        airportCode: '',
        airportName: '',
        time: ''
      }
      state.status = ''
    },
    setLoading (state, value) { state.loading = value},
    setFlightInfo (state, value) {
      state.airline = value.airline
      state.flightNumber = value.flightNumber
      state.departure = value.departure
      state.arrival = value.arrival
      state.status = value.status
      state.type = value.type
    }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/flight-information-modal.js